import { parseAsString, useQueryStates } from 'nuqs';

export default function useExamEventSessionExamineeSearchParams() {
  const [{ search }, setQueryParams] = useQueryStates({
    search: parseAsString.withDefault(''),
  });
  const changeSearch = (search: string) => {
    setQueryParams({ search });
  };

  return [
    {
      search,
    },
    { changeSearch },
  ] as const;
}
